/**
 * Generate a 4-character code with capital letters and numbers
 * Format: [A-Z0-9][A-Z0-9][A-Z0-9][A-Z0-9]
 */
export function generateOnboardingCode(): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let code = ''
  
  for (let i = 0; i < 4; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    code += characters[randomIndex]
  }
  
  return code
}

/**
 * Validate that a code matches the expected format
 */
export function validateOnboardingCode(code: string): boolean {
  if (!code || code.length !== 4) return false
  
  // Check if all characters are uppercase letters or numbers
  const validPattern = /^[A-Z0-9]{4}$/
  return validPattern.test(code)
}
